import React, { useEffect, useMemo, useState } from 'react';
import { Select, Modal, Button } from 'antd';
import IconTriggerModal from "../../Snippets/IconTriggerModal";
import { userApi } from "../../../../../../services/actions/users";
import { useSelector } from "react-redux";

// O valor gravado na automação é uma lista de uuids separada por vírgula — o
// back-end espera o id do usuário. A conversão para lista é só de exibição.
const toTags = (value) => {
    if (Array.isArray(value)) return value.filter(Boolean);
    if (typeof value !== 'string') return [];
    return value.split(',').map((tag) => tag.trim()).filter(Boolean);
};

export const SelectorUser = ({ value, onChange, fieldName, fieldLabel }) => {
    const { company } = useSelector(state => state.user);
    const [options, setOptions] = useState([]);
    const [isModalVisible, setIsModalVisible] = useState(false);

    const tags = useMemo(() => toTags(value), [value]);
    const userValues = useMemo(() => new Set(options.map((option) => option.value)), [options]);

    const handleChange = (newTags) => {
        onChange(newTags.join(','));
    };

    // O modal edita apenas os usuários: anotações ({{ ... }}) inseridas pelos
    // snippets continuam valendo depois de abrir a lista e escolher alguém.
    const handleSelectChange = (selected) => {
        const others = tags.filter((tag) => !userValues.has(tag));
        handleChange([...others, ...selected]);
    };

    const showModal = () => {
        setIsModalVisible(true);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    useEffect(() => {
        if (!company?.unitId) return;
        let active = true;
        const fetchData = async () => {
            const { data } = await userApi.getUsersByUnit(company.unitId, company.companyId)
            if (!active) return;
            const items = data.map((item) => ({
                label: `${item.firstName} ${item.lastName} (${item.email})`,
                value: item.uuid,
            }));
            setOptions(items);
        }
        fetchData()
        return () => { active = false; };
    }, [company?.unitId, company?.companyId]);


    return (
        (<div>
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                {/* `tags` em vez de um Input de texto: o antd resolve o uuid pela
                    lista de opções e mostra o nome do usuário, mas o que sai no
                    onChange continua sendo o uuid. Valores livres seguem aceitos
                    para as anotações dos snippets. */}
                <Select
                    mode="tags"
                    style={{ width: "calc(100% - 140px)" }}
                    value={tags}
                    onChange={handleChange}
                    options={options}
                    optionFilterProp="label"
                    tokenSeparators={[',']}
                    placeholder="Digite ou selecione opções"
                />
                <Button onClick={showModal} style={{ margin: "0 5px" }}>
                    Selecionar opções
                </Button>
                <IconTriggerModal fieldLabel={fieldLabel} fieldName={fieldName} withButton />
            </div>
            <Modal
                title={'Selecionar usuários'}
                open={isModalVisible}
                onCancel={handleCancel}
                footer={null}
                centered
            >
                {/* Sem `filterOption={false}` (que desligava o filtro local sem
                    haver um onSearch para substituí-lo), digitar o nome filtra a
                    lista. */}
                <Select
                    showSearch
                    optionFilterProp="label"
                    mode={"multiple"}
                    style={{ width: "100%" }}
                    value={tags.filter((tag) => userValues.has(tag))}
                    onChange={handleSelectChange}
                    placeholder="Selecionar usuários"
                    options={options}
                >
                </Select>
            </Modal>
        </div>)
    );
};
